import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import AdminContactsComponent from '../components/admin/AdminContacts';
import '../styles/admin.css';

export default function AdminContacts() {
  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <AdminHeader 
          title="Gestion des Contacts" 
          subtitle="Consultez et gérez les messages reçus"
        />
        <AdminContactsComponent />
      </div>
    </div>
  );
}